<template>
  <base-button class="btn-dark" text="閉じる" onclick="window.close()"/>
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'CloseButton',
  components: {
    BaseButton,
  },
}
</script>
